// src/pages/TestPaneerReward.jsx

import React, { useState, useEffect } from "react";
import db from "../Firebase";
import moment from "moment";
import { runFreePaneerRewards } from "../Services/ProductFetch.js";

const GREEN = "#2e7d32";
const ORANGE = "#ef6c00";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "12px",
  border: "none",
  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.04)",
  overflow: "hidden"
};

const headerStyle = {
  backgroundColor: "#f8f9fa",
  borderBottom: "1px solid #edf2f9",
  padding: "15px 20px",
  fontWeight: "600",
  color: "#333"
};

const genId = (prefix) =>
  `${prefix}-${Date.now().toString().slice(-6)}${Math.floor(Math.random() * 90 + 10)}`;

export default function TestPaneerReward() {
  const [testSubs, setTestSubs] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [creating, setCreating] = useState(false);
  const [running, setRunning] = useState(false);
  const [lastResult, setLastResult] = useState(null);
  const [cleaning, setCleaning] = useState(false);

  const [eligibleSubs, setEligibleSubs] = useState([]);
  const [loadingEligible, setLoadingEligible] = useState(false);

  const [form, setForm] = useState({
    customer_name: "Test Customer",
    product_name: "Cow Milk 1 L",
    daysOld: 91,
    resumedOld: "",
  });
  const setF = (k, v) => setForm((f) => ({ ...f, [k]: v }));

 
  const getContinuousDays = (sub) => {
    const effectiveStart = sub.resume_date ? sub.resume_date : sub.start_date;
    if (!effectiveStart) return 0;
    
    const start = effectiveStart?.toDate ? effectiveStart.toDate() : new Date(effectiveStart);
    return moment().startOf("day").diff(moment(start).startOf("day"), "days");
  };

  const loadTestSubs = async () => {
    setLoadingList(true);
    try {
      const snap = await db.collection("subscriptions_data").where("status", "==", "1").get();
      const list = snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter((s) => (s.subscription_id || "").startsWith("TEST-"));

      const withRewardInfo = await Promise.all(
        list.map(async (s) => {
          const daysActive = getContinuousDays(s);
          const rewardSnap = await db
            .collection("order_history")
            .where("subscription_id", "==", s.subscription_id)
            .where("order_type", "==", "Free Paneer Reward")
            .get();
          return { ...s, daysActive, rewardsReceived: rewardSnap.size };
        })
      );
      setTestSubs(withRewardInfo);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingList(false);
    }
  };

  const loadEligibleSubs = async () => {
    setLoadingEligible(true);
    try {
      const snap = await db.collection("subscriptions_data").where("status", "==", "1").get();
      const list = [];
      
      snap.docs.forEach((d) => {
        const sub = d.data();
        if (!sub.product_name || !sub.product_name.includes("Milk")) return;

        const daysActive = getContinuousDays(sub);
        if (daysActive >= 90) list.push({ ...sub, daysActive });
      });
      
      setEligibleSubs(list);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingEligible(false);
    }
  };

  useEffect(() => {
    loadTestSubs();
    loadEligibleSubs();
  }, []);

  const createTestSub = async () => {
    if (!form.product_name.includes("Milk")) {
      alert('Product name mein "Milk" word hona zaroori hai.');
      return;
    }
    setCreating(true);
    try {
      const subscriptionId = genId("TEST");
      const customerId = genId("TESTCUST");
      const startDate = moment().subtract(Number(form.daysOld), "days").toDate();
      
      const subData = {
        subscription_id: subscriptionId,
        customer_id: customerId,
        customer_name: form.customer_name,
        customer_phone: "9999999999",
        product_name: form.product_name,
        package_unit: "1 L",
        price: 60,
        quantity: 1,
        status: "1",
        subscription_type: "Everyday",
        interval: 1,
        start_date: startDate,
        next_delivery_date: moment().add(1, "day").format("YYYY-MM-DD"),
        delivering_to: "Test Address",
        delivered_by: "Test Hub",
        created_date: new Date(),
        updated_date: new Date(),
      };

      if (form.resumedOld && Number(form.resumedOld) > 0) {
        subData.resumed_date = moment().subtract(Number(form.resumedOld), "days").toDate();
      }

      await db.collection("subscriptions_data").add(subData);
      await loadTestSubs();
      await loadEligibleSubs();
      setForm({ ...form, resumedOld: "" });
    } catch (e) {
      console.error(e);
    } finally {
      setCreating(false);
    }
  };

  const handleRun = async () => {
    setRunning(true);
    try {
      const result = await runFreePaneerRewards();
      setLastResult(result);
      await loadTestSubs();
    } catch (e) {
      console.error(e);
    } finally {
      setRunning(false);
    }
  };

  const cleanupAll = async () => {
    if (!window.confirm("⚠️ Dhyan dein: Saari TEST- data delete ho jayegi. Kya aap sure hain?")) return;
    setCleaning(true);
    try {
      for (const sub of testSubs) {
        await db.collection("subscriptions_data").doc(sub.id).delete();
        const orders = await db.collection("order_history").where("subscription_id", "==", sub.subscription_id).get();
        await Promise.all(orders.docs.map((d) => d.ref.delete()));
        const acts = await db.collection("customer_activities").where("customer_id", "==", sub.customer_id).get();
        await Promise.all(acts.docs.map((d) => d.ref.delete()));
      }
      setLastResult(null);
      await loadTestSubs();
      await loadEligibleSubs();
    } catch (e) {
      console.error(e);
    } finally {
      setCleaning(false);
    }
  };

  return (
    <div className="container-scroller" style={{ backgroundColor: "#f4f7f6" }}>
      <div className="container-fluid page-body-wrapper">
        <div className="main-panel w-100" style={{ backgroundColor: "#f4f7f6", minHeight: "100vh" }}>
          <div className="content-wrapper" style={{ padding: "2rem" }}>
            
            {/* Page Title */}
            <div className="mb-4">
              <h2 style={{ fontWeight: 700, color: "#2c3e50", letterSpacing: "-0.5px" }}>
                🧀 Paneer Reward Engine
              </h2>
              <p className="text-muted">Test lagatar (continuous) subscription rules aur auto-reward distribution.</p>
            </div>

            {/* ---------- 1. Test subscription banao ---------- */}
            <div className="card mb-4" style={cardStyle}>
              <div style={headerStyle}>
                1. Nayi Test Subscription Banayein
              </div>
              <div className="card-body">
                <div className="row g-3 align-items-start">
                  <div className="col-md-3">
                    <label className="form-label text-muted small fw-bold mb-1">CUSTOMER NAME</label>
                    <input className="form-control bg-light" value={form.customer_name} onChange={(e) => setF("customer_name", e.target.value)} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label text-muted small fw-bold mb-1">PRODUCT NAME</label>
                    <input className="form-control bg-light" value={form.product_name} onChange={(e) => setF("product_name", e.target.value)} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label text-muted small fw-bold mb-1">DAYS SINCE START</label>
                    <input type="number" className="form-control bg-light" value={form.daysOld} onChange={(e) => setF("daysOld", e.target.value)} />
                    <small className="text-secondary" style={{ fontSize: "11px" }}>Ex: 120 (Started 120 days ago)</small>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label text-danger small fw-bold mb-1">DAYS SINCE RESUME</label>
                    <input type="number" className="form-control border-danger border-opacity-50" placeholder="Empty if never paused" value={form.resumedOld} onChange={(e) => setF("resumedOld", e.target.value)} />
                    <small className="text-secondary" style={{ fontSize: "11px" }}>Ex: 20 (Streak broke, resumed 20 days ago)</small>
                  </div>
                </div>
                <div className="mt-4">
                  <button className="btn text-white px-4 py-2" disabled={creating} onClick={createTestSub} style={{ backgroundColor: GREEN, borderRadius: "6px", fontWeight: 500 }}>
                    {creating ? "Creating..." : "+ Create Test Data"}
                  </button>
                </div>
              </div>
            </div>

            {/* ---------- 2. Engine chalao ---------- */}
            <div className="card mb-4" style={cardStyle}>
              <div className="card-body d-flex justify-content-between align-items-center p-4">
                <div>
                  <h5 style={{ fontWeight: "700", color: "#2c3e50", margin: 0 }}>▶ Reward Engine Chalao</h5>
                  <p className="text-muted mb-0 mt-1" style={{ fontSize: 14 }}>Jo bhi 90 lagatar din pure kar chuke hain, unhe order create ho jayega.</p>
                </div>
                <button className="btn text-white px-4 py-2 shadow-sm" disabled={running} onClick={handleRun} style={{ backgroundColor: ORANGE, borderRadius: "6px", fontWeight: 600 }}>
                  {running ? "Processing..." : "Run Engine Now"}
                </button>
              </div>

              {/* Result Area */}
              {lastResult && (
                <div className="card-body border-top bg-light">
                  <p className="mb-3" style={{ fontWeight: 600, color: "#444" }}>
                    📊 Checked {lastResult.checked} active subscriptions.
                  </p>
                  {lastResult.rewarded.length === 0 ? (
                    <div className="alert alert-secondary mb-0 border-0">Koi naya reward due nahi tha.</div>
                  ) : (
                    <table className="table table-bordered bg-white mb-0">
                      <thead className="table-light text-muted">
                        <tr>
                          <th className="fw-bold">Customer Name</th>
                          <th className="fw-bold">Subscription ID</th>
                          <th className="fw-bold text-center">Rewards Given</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lastResult.rewarded.map((r, i) => (
                          <tr key={i}>
                            <td className="align-middle">{r.customer_name}</td>
                            <td className="align-middle text-primary">{r.subscription_id}</td>
                            <td className="align-middle text-center">
                              <span className="badge bg-success" style={{ fontSize: "14px" }}>+{r.rewardsGiven} Paneer</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>

            {/* ---------- 3 & 4 (Data Tables) ---------- */}
            <div className="row g-4">
              
              {/* Table 1: All Test Subscriptions */}
              <div className="col-lg-6">
                <div className="card h-100" style={cardStyle}>
                  <div style={{...headerStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <span>🧪 Current Test Data</span>
                    <button className="btn btn-sm btn-outline-danger" onClick={cleanupAll} disabled={cleaning || testSubs.length === 0}>
                      🗑 Clear Data
                    </button>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0 text-center">
                        <thead className="table-light text-muted small">
                          <tr>
                            <th className="text-start ps-4">Sub ID</th>
                            <th>Continuous Days</th>
                            <th className="pe-4">Eligible?</th>
                          </tr>
                        </thead>
                        <tbody>
                          {testSubs.length === 0 ? (
                            <tr><td colSpan="3" className="py-4 text-muted">No test data available.</td></tr>
                          ) : (
                            testSubs.map((s) => (
                              <tr key={s.id}>
                                <td className="text-start ps-4 fw-medium">{s.subscription_id}</td>
                                <td>{s.daysActive}</td>
                                <td className="pe-4">
                                  {s.daysActive >= 90 
                                    ? <span className="badge bg-success">Haan</span> 
                                    : <span className="badge bg-danger">Nahi</span>}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table 2: Eligible Real + Test Subscriptions */}
              <div className="col-lg-6">
                <div className="card h-100" style={cardStyle}>
                  <div style={{...headerStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <span>🏆 90+ Days (Real & Test)</span>
                    <button className="btn btn-sm btn-outline-secondary" onClick={loadEligibleSubs} disabled={loadingEligible}>
                      ↻ Refresh
                    </button>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0">
                        <thead className="table-light text-muted small">
                          <tr>
                            <th className="ps-4">Customer</th>
                            <th>Sub ID</th>
                            <th>cust ID</th>
                            <th className="text-center pe-4">Streak (Days)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {eligibleSubs.length === 0 ? (
                            <tr><td colSpan="3" className="text-center py-4 text-muted">No eligible users right now.</td></tr>
                          ) : (
                            eligibleSubs.map((s, idx) => (
                              <tr key={idx}>
                                <td className="ps-4 text-truncate" style={{maxWidth: "120px"}}>{s.customer_name}</td>
                                <td className="text-muted small">{s.subscription_id}</td>
                                <td className="text-muted small">{s.customer_id}</td>
                                <td className="text-center pe-4 text-success fw-bold">🔥 {s.daysActive}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}